export enum HomeMatchConfigurationSourceSection {
    RP_APPLICATION_SEND_MODAL = 1,
    RP_APPLICATION_SEND_STAY = 2,
    RP_SHOW_PRICE_MODAL = 3,
    RP_SHOW_PRICE_STAY = 4,
    KM_ONBOARDING_MODAL = 5,
    KM_ONBOARDING_STAY = 6,
    KM_PREFERENCES_MODAL = 7,
    KM_PREFERENCES_STAY = 8
}
export enum HomeMatchConfigurationSourceSection {
    RP_APPLICATION_SEND_MODAL = 1,
    RP_APPLICATION_SEND_STAY = 2,
    RP_SHOW_PRICE_MODAL = 3,
    RP_SHOW_PRICE_STAY = 4,
    KM_ONBOARDING_MODAL = 5,
    KM_ONBOARDING_STAY = 6,
    KM_PREFERENCES_MODAL = 7,
    KM_PREFERENCES_STAY = 8
}
